import React, { useState, createContext, useEffect } from 'react';
import axios from '../Util/axiosConfig';
import { baseUrl } from '../Contants';

export const CompanyLogoContext = createContext();

// Module-level in-flight dedup. This provider is mounted more than once at a time on
// some routes (the app-level instance wrapping Header + a route-level instance on
// /signin, /register, /confirm-user, /settings, /about), which fired the logo and
// logolink requests twice. Sharing the in-flight promise means concurrent instances
// reuse a single network round-trip; it resets on completion so a later logo update
// still refetches.
let companyLogoInFlight = null;
let logoLinkInFlight = null;

export const CompanyLogoContextProvider = ({ children }) => {
  const [companyLogo, setCompanyLogo] = useState('');
  const [update, setUpdate] = useState(false);
  const [logoLink, setLogoLink] = useState('http://www.yoursite.com');
  const [logoLinkData, setLogoLinkData] = useState([]);

  useEffect(() => {
    let abortController = new AbortController();
    async function getCompanyLogo() {
      if (!companyLogoInFlight) {
        companyLogoInFlight = axios(`${baseUrl}/api/app/company/logo`).finally(() => {
          companyLogoInFlight = null;
        });
      }
      const result = await companyLogoInFlight;
      setCompanyLogo(result.data.companyLogo);
      setUpdate(false);
    }

    async function getLogoLink() {
      if (!logoLinkInFlight) {
        logoLinkInFlight = axios(`${baseUrl}/api/admin/logolink/get`).finally(() => {
          logoLinkInFlight = null;
        });
      }
      const result = await logoLinkInFlight;
      setLogoLink(result.data.data[0].logo_link);
      setLogoLinkData(result.data.data);
    }

    getCompanyLogo();
    getLogoLink();
    return () => {
      abortController.abort();
    };
  }, [update]);

  return (
    <CompanyLogoContext.Provider
      value={{ companyLogo, setUpdate, logoLink, logoLinkData }}
    >
      {children}
    </CompanyLogoContext.Provider>
  );
};
